import { Container } from "@components/ui/Container";
import { Button } from "@components/ui/Button";
import { company } from "@data/company";
import styles from "./Hero.module.css";

export function Hero() {
  return (
    <section className={styles.hero}>
      <Container>
        <div className={styles.grid}>
          <div>
            <div className={styles.eyebrow}>
              <span aria-hidden /> Atención humana, no respuestas automáticas
            </div>
            <h1 className={styles.title}>
              Seguros con asesoría <em>real</em>, no respuestas automáticas.
            </h1>
            <p className={styles.subtitle}>
              Comparamos coberturas entre las principales aseguradoras del país
              con productores que te acompañan en cada paso.
            </p>
            <div className={styles.actions}>
              <Button
                as="a"
                href={`https://wa.me/${company.whatsapp}?text=${encodeURIComponent(
                  "Hola, quiero una cotización",
                )}`}
                target="_blank"
                rel="noopener"
                variant="cta"
                size="lg"
              >
                Cotizá tu seguro
              </Button>
              <Button as="a" href="/productos" variant="secondary" size="lg">
                Ver productos
              </Button>
            </div>

            <div className={styles.stats}>
              <div className={styles.stat}>
                <strong>+30</strong>
                <span>Años en el mercado</span>
              </div>
              <div className={styles.stat}>
                <strong>+5.000</strong>
                <span>Clientes activos</span>
              </div>
              <div className={styles.stat}>
                <strong>24h</strong>
                <span>Para cotizar</span>
              </div>
            </div>
          </div>

          <div className={styles.visual} aria-hidden>
            <div className={styles.visualInner} />
            <div className={styles.shieldCard}>
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                <path
                  d="M32 6 L54 14 V32 C54 44 44 54 32 58 C20 54 10 44 10 32 V14 Z"
                  fill="rgba(255,255,255,0.12)"
                  stroke="#2db5e8"
                  strokeWidth="2"
                />
                <path
                  d="M22 32 L29 39 L42 24"
                  stroke="#2db5e8"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                />
              </svg>
              <h3>Cobertura garantizada</h3>
              <p>Productores matriculados, respaldados por el broker.</p>
            </div>
            <div className={styles.floatA}>
              <span className={`${styles.dot} ${styles.dotGreen}`} />
              Siniestro resuelto
            </div>
            <div className={styles.floatB}>
              <span className={`${styles.dot} ${styles.dotAmber}`} />
              Cotización en 24hs
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
